<button
  mat-raised-button
  matSnackBarAction
  color="accent"
  class="w-100 falcon-rounded-btn"
  (click)="save()"
>
  {{ 'SHARED.FORM_SAVE_ACTION.SAVE_CHANGES' | translate }}
</button>
